﻿package com.mgacreative.hotelru.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class KbsNotification(
    val id: String = "",
    @SerialName("guest_type") val guestType: String = "TC Vatandaşı", // "TC Vatandaşı" veya "Yabancı"
    @SerialName("identity_no") val identityNo: String = "", // TC Kimlik No veya Pasaport No
    @SerialName("first_name") val firstName: String = "",
    @SerialName("last_name") val lastName: String = "",
    @SerialName("birth_date") val birthDate: String = "",
    @SerialName("room_number") val roomNumber: String = "",
    @SerialName("check_in_date_time") val checkInDateTime: String = "",
    @SerialName("check_out_date_time") val checkOutDateTime: String = "",
    val nationality: String = "TR",
    val status: String = "BEKLİYOR" // BEKLİYOR, BİLDİRİLDİ
)

